export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Wan 2.5 视频生成器 - 先进AI视频创作平台',
        pageDescription: '体验Wan 2.5视频生成器，专注于高质量视频创作和创意表达。支持多种视频生成模式，根据文本描述或图像输入生成精美视频内容。在WeryAI平台免费试用。',
        pageKeywords: 'Wan 2.5, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Wan 2.5 视频生成器',
        generatorDescription: 'Wan 2.5 是由中国电商巨头阿里巴巴推出的一款先进的 AI 图像和视频生成工具，该公司最近宣布计划向云计算和人工智能投资超过 500 亿美元。其',
        generatorDescriptionHighlight1: 'Wan 2.5 模型现已集成到 微鲤AI 视频生成器中，可生成逼真的视频',
        generatorDescriptionText2: '。点击此处',
        generatorDescriptionHighlight2: '免费试用 Wan 2.5',
        generatorDescriptionEnd: '！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.5 视频模型的主要功能',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '原生音频集成',
        nativeAudioIntegrationDescription: '自动生成声音，支持自定义音频上传，也可选',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '升级的动态效果',
        enhancedDynamicEffectsDescription: '渲染复杂动作，细节更流畅自然',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '精确的摄像机控制',
        preciseCameraControlDescription: '为电影级视频制作提供更大的带宽。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '增强的视觉真实感',
        enhancedVisualRealismDescription: '更丰富、更精细的场景构图',

        // 改进的上下文理解功能
        improvedContextUnderstandingTitle: '改进的上下文理解',
        improvedContextUnderstandingDescription: '更好地解读复杂的角色动作和创意场景指导。',

        // 如何使用部分
        howToUseTitle: 'How to Use',
        step1Title: '选择Wan 2.5模型',
        step1Description: '前往"AI视频生成"页面，然后在模型下拉菜单中点击"Wan 2.5"。',
        step1DescriptionHighlight: 'AI视频生成',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，并调整相关参数设置。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的高质量视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Wan 2.5 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Wan 2.5 AI 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        seedanceTitle: 'Seedance 1.0 Pro 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Wan 2.5是什么?',
        faq1Answer: 'Wan 2.5是一款先进的AI视频生成平台，专注于高质量视频创作和创意表达。它支持多种视频生成模式，能够根据文本描述或图像输入生成精美的视频内容。',
        faq2Question: 'Wan 2.5有哪些主要功能?',
        faq2Answer: 'Wan 2.5主要功能包括：高质量视频生成、创意表达支持、多模态输入支持、高级控制选项等。它能够生成高分辨率、细节丰富的视频内容，支持多种艺术风格和创意表达方式。',
        faq3Question: '我能免费使用Wan 2.5吗?',
        faq3Answer: '是的。Wan 2.5通过WeryAI的免费试用提供有限的免费额度。如需大量使用，则需要升级。',
        faq4Question: 'Wan 2.5支持哪些输入方式?',
        faq4Answer: 'Wan 2.5支持多种输入方式，包括文本描述、图像输入、音频等。这种多模态输入支持让您能够通过不同的媒介来表达和实现创意想法。',
        faq5Question: '我可以使用 Wan 2.5用于专业或商业项目吗?',
        faq5Answer: '是的。Wan 2.5的高质量视频生成和强大的创意表达功能使其成为专业视频制作人、内容创作者和商业用户的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.5，将您的创意转化为精彩视频',
        ctaButton: 'Try Wan 2.5 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle: 'Wan 2.5 Video Generator - Advanced AI Video Creation Platform',
        pageDescription: 'Experience Wan 2.5 video generator focused on high-quality video creation and creative expression. Supports multiple video generation modes to generate beautiful video content based on text descriptions or image inputs. Try it free on 微鲤AI platform.',
        pageKeywords: 'Wan 2.5, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, 微鲤AI, video production',

        // Generator section
        generatorTitle: 'Wan 2.5 Video Generator',
        generatorDescription: 'Wan 2.5 is an advanced AI image and video generation tool launched by Chinese e-commerce giant Alibaba, which recently announced plans to invest over $50 billion in cloud computing and artificial intelligence. Its',
        generatorDescriptionHighlight1: 'Wan 2.5 model is now integrated into 微鲤AI video generator and can generate realistic videos',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'try Wan 2.5 for free',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Main Features of Wan 2.5 Video Model',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Native Audio Integration',
        nativeAudioIntegrationDescription: 'Automatically generates audio, supports custom audio upload, optional',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Enhanced Dynamic Effects',
        enhancedDynamicEffectsDescription: 'Renders complex actions with smoother and more natural details',

        // Precise camera control feature
        preciseCameraControlTitle: 'Precise Camera Control',
        preciseCameraControlDescription: 'Provides greater bandwidth for cinematic video production.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Enhanced Visual Realism',
        enhancedVisualRealismDescription: 'Richer and more refined scene composition',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Improved Context Understanding',
        improvedContextUnderstandingDescription: 'Better interprets complex character actions and creative scene guidance.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Wan 2.5 Model',
        step1Description: 'Go to the "AI Video Generation" page, then click "Wan 2.5" in the model dropdown menu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe the content you want to generate, or upload images for conversion, and adjust relevant parameter settings.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to freely download or share the generated high-quality video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Wan 2.5 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Wan 2.5 AI Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        seedanceTitle: 'Seedance 1.0 Pro Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Wan 2.5?',
        faq1Answer: 'Wan 2.5 is an advanced AI video generation platform focused on high-quality video creation and creative expression. It supports multiple video generation modes and can generate beautiful video content based on text descriptions or image inputs.',
        faq2Question: 'What are the main features of Wan 2.5?',
        faq2Answer: 'Wan 2.5\'s main features include: high-quality video generation, creative expression support, multimodal input support, advanced control options, etc. It can generate high-resolution, detail-rich video content and supports various artistic styles and creative expression methods.',
        faq3Question: 'Can I use Wan 2.5 for free?',
        faq3Answer: 'Yes. Wan 2.5 provides limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What input methods does Wan 2.5 support?',
        faq4Answer: 'Wan 2.5 supports multiple input methods, including text descriptions, image inputs, audio, etc. This multimodal input support allows you to express and realize creative ideas through different media.',
        faq5Question: 'Can I use Wan 2.5 for professional or commercial projects?',
        faq5Answer: 'Yes. Wan 2.5\'s high-quality video generation and powerful creative expression capabilities make it a strong choice for professional video producers, content creators, and commercial users.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Wan 2.5 now and transform your creativity into amazing videos',
        ctaButton: 'Try Wan 2.5 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle: 'Wan 2.5動画ジェネレーター - 先進AI動画作成プラットフォーム',
        pageDescription: 'Wan 2.5動画ジェネレーターを体験。高品質動画作成と創造的表現に特化。複数の動画生成モードをサポートし、テキスト記述や画像入力に基づいて美しい動画コンテンツを生成。WeryAIプラットフォームで無料試用。',
        pageKeywords: 'Wan 2.5, AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, 微鲤AI, 動画制作',

        // ジェネレーター部分
        generatorTitle: 'Wan 2.5動画ジェネレーター',
        generatorDescription: 'Wan 2.5は、高品質動画作成と創造的表現に特化した先進的なAI動画生成プラットフォームです。複数の動画生成モードをサポートし、テキスト記述や画像入力に基づいて美しい動画コンテンツを生成できます。WeryAI動画ジェネレーターでWan 2.5を無料でお試しください！',
        
        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Wan 2.5 の主要機能',

        // 高品質動画生成機能
        highQualityGenerationTitle: '高品質動画生成',
        highQualityGenerationDescription: '先進的なAI技術を使用し、高解像度で詳細に富んだ動画コンテンツを生成し、すべてのフレームがプロフェッショナルグレードの品質基準を満たすことを保証します。',

        // 創造的表現機能
        creativeExpressionTitle: '創造的表現',
        creativeExpressionDescription: '複数の創造的表現方法をサポートし、あなたのアイデアが最も適切な形で表現され、ユニークな視覚体験を作り出します。',

        // マルチモード生成機能
        multiModeGenerationTitle: 'マルチモード生成',
        multiModeGenerationDescription: 'テキストから動画、画像から動画などの複数の生成モードをサポートし、異なる創造的ニーズを満たし、柔軟な動画作成体験を提供します。',

        // インテリジェント最適化機能
        intelligentOptimizationTitle: 'インテリジェント最適化',
        intelligentOptimizationDescription: 'インテリジェント最適化アルゴリズムを使用し、動画パラメータを自動調整して、生成されたコンテンツが最適な品質効果を達成することを保証します。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'Wan 2.5モデル選択',
        step1Description: 'AI動画ツールでWan 2.5モデルを選択',
        step2Title: 'コンテンツ入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '動画生成',
        step3Description: '生成ボタンをクリックし、待機して動画をダウンロード',

        // YouTube動画部分
        youtubeTitle: 'Wan 2.5動画ジェネレーターに関するYouTube動画',

        // X投稿部分
        xPostsTitle: 'Wan 2.5動画ジェネレーターに関するX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他の動画モデルを探索',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        klingTitle: 'Kling AI動画ジェネレーター',
        veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',
        seedanceTitle: 'Seedance 1.0 Pro 動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',
        faq1Question: 'Wan 2.5とは何ですか？',
        faq1Answer: 'Wan 2.5は、高品質動画作成と創造的表現に特化した先進的なAI動画生成プラットフォームです。複数の動画生成モードをサポートし、テキスト記述や画像入力に基づいて美しい動画コンテンツを生成し、ユーザーにプロフェッショナルな動画作成体験を提供します。',
        faq2Question: 'Wan 2.5の特別な機能は何ですか？',
        faq2Answer: 'Wan 2.5の主な特別な機能には以下が含まれます：1）プロフェッショナルグレードの品質基準を保証する高品質動画生成；2）複数の表現方法をサポートする創造的表現；3）テキストから動画、画像から動画などをサポートするマルチモード生成；4）動画パラメータを自動調整するインテリジェント最適化。',
        faq3Question: 'WeryAIでWan 2.5を無料で使用できますか？',
        faq3Answer: 'はい！WeryAIはWan 2.5の無料試用サービスを提供しています。アカウントを登録してすぐに使用を開始し、Wan 2.5の強力な機能を体験できます。ユーザーが体験するための一定の無料クレジットを提供し、無料クォータを超えた後はより多くのクレジットを購入して継続使用できます。',
        faq4Question: 'Wan 2.5はどのような生成モードをサポートしていますか？',
        faq4Answer: 'Wan 2.5はテキストから動画、画像から動画などの複数の生成モードをサポートしています。テキストを記述して動画を生成したり、参照画像をアップロードして動画生成プロセスをガイドしたりでき、異なる創造的ニーズを満たします。',
        faq5Question: 'Wan 2.5の生成品質はどうですか？',
        faq5Answer: 'Wan 2.5は先進的なAI技術を使用し、高解像度で詳細に富んだ動画コンテンツを生成します。すべてのフレームがプロフェッショナルグレードの品質基準を満たすことを保証し、リアルで滑らかな視覚体験を提供します。',
        faq6Question: 'Wan 2.5はどのようなタイプの動画作成に適していますか？',
        faq6Answer: 'Wan 2.5は以下のような様々なタイプの動画作成に適しています：1）創造的な短編映画制作；2）ソーシャルメディアコンテンツ作成；3）製品紹介動画；4）教育コンテンツ制作；5）芸術創作など。',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐWan 2.5を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでWan 2.5を試す',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
            generatorDescriptionHighlight1: 'プロ級の映画制作',
            generatorDescriptionText2: '印象的な感情表現、強化された視覚構成、',
            generatorDescriptionHighlight2: 'カメラ操作、映画美学',
            generatorDescriptionEnd: '文脈理解、動きの物理学を備えています。',
            nativeAudioIntegrationTitle: 'ネイティブオーディオ統合',
            nativeAudioIntegrationDescription: 'Wan 2.1は高度なオーディオ同期機能を備え、没入感のある視聴体験を提供します。',
            enhancedDynamicEffectsTitle: '強化されたダイナミック効果',
            enhancedDynamicEffectsDescription: 'より自然でリアルな動きと特殊効果を実現。',
            preciseCameraControlTitle: '精密なカメラ制御',
            preciseCameraControlDescription: '監督レベルのカメラワークとフォーカス制御が可能。',
            enhancedVisualRealismTitle: '強化された視覚的リアリズム',
            enhancedVisualRealismDescription: '光影とテクスチャの表現が大幅に向上。',
            improvedContextUnderstandingTitle: '改善された文脈理解',
            improvedContextUnderstandingDescription: '複雑なプロンプトを正確に解釈し、意図通りの映像を生成。',
            step1DescriptionHighlight: 'AI動画生成',
            runwayTitle: 'Runway AI動画ジェネレーター',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Wan 2.5 비디오 생성기 - 고급 AI 비디오 제작 플랫폼',
        pageDescription: 'Wan 2.5 비디오 생성기를 체험하세요. 고품질 비디오 제작과 창의적 표현에 특화. 여러 비디오 생성 모드를 지원하여 텍스트 설명이나 이미지 입력에 기반하여 아름다운 비디오 콘텐츠를 생성합니다. 微鲤AI 플랫폼에서 무료로 체험하세요.',
        pageKeywords: 'Wan 2.5, AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, 微鲤AI, 비디오 제작',

        // 생성기 부분
        generatorTitle: 'Wan 2.5 비디오 생성기',
        generatorDescription: 'Wan 2.5는 고품질 비디오 제작과 창의적 표현에 특화된 고급 AI 비디오 생성 플랫폼입니다. 여러 비디오 생성 모드를 지원하며 텍스트 설명이나 이미지 입력에 기반하여 아름다운 비디오 콘텐츠를 생성할 수 있습니다. 微鲤AI 비디오 생성기에서 Wan 2.5를 무료로 체험해보세요!',
        
        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Wan 2.5 주요 기능',

        // 고품질 비디오 생성 기능
        highQualityGenerationTitle: '고품질 비디오 생성',
        highQualityGenerationDescription: '고급 AI 기술을 사용하여 고해상도이고 세부사항이 풍부한 비디오 콘텐츠를 생성하며, 모든 프레임이 전문가급 품질 기준을 충족하도록 보장합니다.',

        // 창의적 표현 기능
        creativeExpressionTitle: '창의적 표현',
        creativeExpressionDescription: '여러 창의적 표현 방법을 지원하여 당신의 아이디어가 가장 적절한 형태로 표현되도록 하고 독특한 시각적 경험을 만들어냅니다.',

        // 멀티모드 생성 기능
        multiModeGenerationTitle: '멀티모드 생성',
        multiModeGenerationDescription: '텍스트에서 비디오, 이미지에서 비디오 등 여러 생성 모드를 지원하여 다양한 창의적 요구사항을 충족하고 유연한 비디오 제작 경험을 제공합니다.',

        // 지능형 최적화 기능
        intelligentOptimizationTitle: '지능형 최적화',
        intelligentOptimizationDescription: '지능형 최적화 알고리즘을 사용하여 비디오 매개변수를 자동으로 조정하고 생성된 콘텐츠가 최적의 품질 효과를 달성하도록 보장합니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: 'Wan 2.5 모델 선택',
        step1Description: 'AI 비디오 도구에서 Wan 2.5 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '비디오 생성',
        step3Description: '생성 버튼 클릭, 대기 후 비디오 다운로드',

        // YouTube 비디오 부분
        youtubeTitle: 'Wan 2.5 비디오 생성기에 대한 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Wan 2.5 비디오 생성기에 대한 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        klingTitle: 'Kling AI 비디오 생성기',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        seedanceTitle: 'Seedance 1.0 Pro 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Wan 2.5가 무엇인가요?',
        faq1Answer: 'Wan 2.5는 고품질 비디오 제작과 창의적 표현에 특화된 고급 AI 비디오 생성 플랫폼입니다. 여러 비디오 생성 모드를 지원하며 텍스트 설명이나 이미지 입력에 기반하여 아름다운 비디오 콘텐츠를 생성하여 사용자에게 전문적인 비디오 제작 경험을 제공합니다.',
        faq2Question: 'Wan 2.5의 특별한 기능은 무엇인가요?',
        faq2Answer: 'Wan 2.5의 주요 특별한 기능은 다음과 같습니다: 1) 전문가급 품질 기준을 보장하는 고품질 비디오 생성; 2) 여러 표현 방법을 지원하는 창의적 표현; 3) 텍스트에서 비디오, 이미지에서 비디오 등을 지원하는 멀티모드 생성; 4) 비디오 매개변수를 자동으로 조정하는 지능형 최적화.',
        faq3Question: 'WeryAI에서 Wan 2.5를 무료로 사용할 수 있나요?',
        faq3Answer: '네! WeryAI는 Wan 2.5의 무료 체험 서비스를 제공합니다. 계정을 등록하고 즉시 사용을 시작하여 Wan 2.5의 강력한 기능을 체험할 수 있습니다. 사용자가 체험할 수 있는 일정한 무료 크레딧을 제공하며, 무료 할당량을 초과한 후에는 더 많은 크레딧을 구매하여 계속 사용할 수 있습니다.',
        faq4Question: 'Wan 2.5는 어떤 생성 모드를 지원하나요?',
        faq4Answer: 'Wan 2.5는 텍스트에서 비디오, 이미지에서 비디오 등 여러 생성 모드를 지원합니다. 텍스트를 설명하여 비디오를 생성하거나 참조 이미지를 업로드하여 비디오 생성 과정을 안내할 수 있어 다양한 창의적 요구사항을 충족합니다.',
        faq5Question: 'Wan 2.5의 생성 품질은 어떤가요?',
        faq5Answer: 'Wan 2.5는 고급 AI 기술을 사용하여 고해상도이고 세부사항이 풍부한 비디오 콘텐츠를 생성합니다. 모든 프레임이 전문가급 품질 기준을 충족하도록 보장하여 현실적이고 부드러운 시각적 경험을 제공합니다.',
        faq6Question: 'Wan 2.5는 어떤 유형의 비디오 제작에 적합한가요?',
        faq6Answer: 'Wan 2.5는 다음과 같은 다양한 유형의 비디오 제작에 적합합니다: 1) 창의적인 단편 영화 제작; 2) 소셜 미디어 콘텐츠 제작; 3) 제품 쇼케이스 비디오; 4) 교육 콘텐츠 제작; 5) 예술 창작 등.',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Wan 2.5를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Wan 2.5 체험하기',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoReload: '다시 로드',
            generatorDescriptionHighlight1: '감독 수준의 영화 제작',
            generatorDescriptionText2: '인상적인 감정 표현, 강화된 시각적 구성,',
            generatorDescriptionHighlight2: '카메라 제어, 영화적 미학',
            generatorDescriptionEnd: '문맥 이해, 동작 물리학을 갖추고 있습니다.',
            nativeAudioIntegrationTitle: '네이티브 오디오 통합',
            nativeAudioIntegrationDescription: 'Wan 2.1은 고급 오디오 동기화 기능을 갖춰 몰입감 넘치는 시청 경험을 제공합니다.',
            enhancedDynamicEffectsTitle: '강화된 역동적 효과',
            enhancedDynamicEffectsDescription: '더욱 자연스럽고 사실적인 움직임과 특수 효과를 구현합니다.',
            preciseCameraControlTitle: '정밀한 카메라 제어',
            preciseCameraControlDescription: '감독 수준의 카메라 워크와 포커스 제어가 가능합니다.',
            enhancedVisualRealismTitle: '강화된 시각적 사실감',
            enhancedVisualRealismDescription: '빛과 그림자, 질감 표현이 크게 향상되었습니다.',
            improvedContextUnderstandingTitle: '개선된 문맥 이해',
            improvedContextUnderstandingDescription: '복잡한 프롬프트를 정확하게 해석하여 의도한 영상을 생성합니다.',
            step1DescriptionHighlight: 'AI 비디오 생성',
            runwayTitle: 'Runway AI 비디오 생성기',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Wan 2.5 视频生成器 - 先进AI视频创作平台',
        pageDescription: '体验Wan 2.5视频生成器，专注于高质量视频创作和创意表达。支持多种视频生成模式，根据文本描述或图像输入生成精美视频内容。在WeryAI平台免费试用。',
        pageKeywords: 'Wan 2.5, AI视频生成器, AI视频创作, 人工智能视频, 视频生成工具, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Wan 2.5 视频生成器',
        generatorDescription: 'Wan 2.5 是由中国电商巨头阿里巴巴推出的一款先进的 AI 图像和视频生成工具，该公司最近宣布计划向云计算和人工智能投资超过 500 亿美元。其',
        generatorDescriptionHighlight1: 'Wan 2.5 模型现已集成到 微鲤AI 视频生成器中，可生成逼真的视频',
        generatorDescriptionText2: '。点击此处',
        generatorDescriptionHighlight2: '免费试用 Wan 2.5',
        generatorDescriptionEnd: '！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.5 视频模型的主要功能',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '原生音频集成',
        nativeAudioIntegrationDescription: '自动生成声音，支持自定义音频上传，也可选',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '升级的动态效果',
        enhancedDynamicEffectsDescription: '渲染复杂动作，细节更流畅自然',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '精确的摄像机控制',
        preciseCameraControlDescription: '为电影级视频制作提供更大的带宽。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '增强的视觉真实感',
        enhancedVisualRealismDescription: '更丰富、更精细的场景构图',

        // 改进的上下文理解功能
        improvedContextUnderstandingTitle: '改进的上下文理解',
        improvedContextUnderstandingDescription: '更好地解读复杂的角色动作和创意场景指导。',

        // 如何使用部分
        howToUseTitle: 'How to Use',
        step1Title: '选择Wan 2.5模型',
        step1Description: '前往"AI视频生成"页面，然后在模型下拉菜单中点击"Wan 2.5"。',
        step1DescriptionHighlight: 'AI视频生成',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，并调整相关参数设置。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的高质量视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Wan 2.5 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Wan 2.5 AI 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        seedanceTitle: 'Seedance 1.0 Pro 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Wan 2.5是什么?',
        faq1Answer: 'Wan 2.5是一款先进的AI视频生成平台，专注于高质量视频创作和创意表达。它支持多种视频生成模式，能够根据文本描述或图像输入生成精美的视频内容。',
        faq2Question: 'Wan 2.5有哪些主要功能?',
        faq2Answer: 'Wan 2.5主要功能包括：高质量视频生成、创意表达支持、多模态输入支持、高级控制选项等。它能够生成高分辨率、细节丰富的视频内容，支持多种艺术风格和创意表达方式。',
        faq3Question: '我能免费使用Wan 2.5吗?',
        faq3Answer: '是的。Wan 2.5通过WeryAI的免费试用提供有限的免费额度。如需大量使用，则需要升级。',
        faq4Question: 'Wan 2.5支持哪些输入方式?',
        faq4Answer: 'Wan 2.5支持多种输入方式，包括文本描述、图像输入、音频等。这种多模态输入支持让您能够通过不同的媒介来表达和实现创意想法。',
        faq5Question: '我可以使用 Wan 2.5用于专业或商业项目吗?',
        faq5Answer: '是的。Wan 2.5的高质量视频生成和强大的创意表达功能使其成为专业视频制作人、内容创作者和商业用户的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.5，将您的创意转化为精彩视频',
        ctaButton: 'Try Wan 2.5 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle: 'Wan 2.5 Video Generator - Advanced AI Video Creation Platform',
        pageDescription: 'Experience Wan 2.5 video generator focused on high-quality video creation and creative expression. Supports multiple video generation modes to generate beautiful video content based on text descriptions or image inputs. Try it free on 微鲤AI platform.',
        pageKeywords: 'Wan 2.5, AI video generator, AI video creation, artificial intelligence video, video generation tool, free AI video, 微鲤AI, video production',

        // Generator section
        generatorTitle: 'Wan 2.5 Video Generator',
        generatorDescription: 'Wan 2.5 is an advanced AI image and video generation tool launched by Chinese e-commerce giant Alibaba, which recently announced plans to invest over $50 billion in cloud computing and artificial intelligence. Its',
        generatorDescriptionHighlight1: 'Wan 2.5 model is now integrated into 微鲤AI video generator and can generate realistic videos',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'try Wan 2.5 for free',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Main Features of Wan 2.5 Video Model',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Native Audio Integration',
        nativeAudioIntegrationDescription: 'Automatically generates audio, supports custom audio upload, optional',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Enhanced Dynamic Effects',
        enhancedDynamicEffectsDescription: 'Renders complex actions with smoother and more natural details',

        // Precise camera control feature
        preciseCameraControlTitle: 'Precise Camera Control',
        preciseCameraControlDescription: 'Provides greater bandwidth for cinematic video production.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Enhanced Visual Realism',
        enhancedVisualRealismDescription: 'Richer and more refined scene composition',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Improved Context Understanding',
        improvedContextUnderstandingDescription: 'Better interprets complex character actions and creative scene guidance.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Wan 2.5 Model',
        step1Description: 'Go to the "AI Video Generation" page, then click "Wan 2.5" in the model dropdown menu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe the content you want to generate, or upload images for conversion, and adjust relevant parameter settings.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to freely download or share the generated high-quality video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Wan 2.5 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Wan 2.5 AI Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        seedanceTitle: 'Seedance 1.0 Pro Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Wan 2.5?',
        faq1Answer: 'Wan 2.5 is an advanced AI video generation platform focused on high-quality video creation and creative expression. It supports multiple video generation modes and can generate beautiful video content based on text descriptions or image inputs.',
        faq2Question: 'What are the main features of Wan 2.5?',
        faq2Answer: 'Wan 2.5\'s main features include: high-quality video generation, creative expression support, multimodal input support, advanced control options, etc. It can generate high-resolution, detail-rich video content and supports various artistic styles and creative expression methods.',
        faq3Question: 'Can I use Wan 2.5 for free?',
        faq3Answer: 'Yes. Wan 2.5 provides limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What input methods does Wan 2.5 support?',
        faq4Answer: 'Wan 2.5 supports multiple input methods, including text descriptions, image inputs, audio, etc. This multimodal input support allows you to express and realize creative ideas through different media.',
        faq5Question: 'Can I use Wan 2.5 for professional or commercial projects?',
        faq5Answer: 'Yes. Wan 2.5\'s high-quality video generation and powerful creative expression capabilities make it a strong choice for professional video producers, content creators, and commercial users.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Wan 2.5 now and transform your creativity into amazing videos',
        ctaButton: 'Try Wan 2.5 on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle: 'Generador de Video Wan 2.5 - Plataforma Avanzada de Creación de Video IA',
        pageDescription: 'Experimenta el generador de video Wan 2.5 enfocado en creación de video de alta calidad y expresión creativa. Soporta múltiples modos de generación de video para crear hermoso contenido de video basado en descripciones de texto o entradas de imagen. Pruébalo gratis en la plataforma 微鲤AI.',
        pageKeywords: 'Wan 2.5, generador de video IA, creación de video IA, video de inteligencia artificial, herramienta de generación de video, video IA gratis, 微鲤AI, producción de video',
    
        // Sección del generador
        generatorTitle: 'Generador de Video Wan 2.5',
        generatorDescription: 'Wan 2.5 es una herramienta avanzada de generación de imágenes y videos IA lanzada por el gigante chino del comercio electrónico Alibaba, que recientemente anunció planes para invertir más de $50 mil millones en computación en la nube e inteligencia artificial. Su',
        generatorDescriptionHighlight1: 'modelo Wan 2.5 ahora está integrado en el generador de video 微鲤AI y puede generar videos realistas',
        generatorDescriptionText2: '. Haz clic aquí para',
        generatorDescriptionHighlight2: 'probar Wan 2.5 gratis',
        generatorDescriptionEnd: '!',
        
        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',
    
        // Sección de características principales
        coreFeaturesTitle: 'Características Principales del Modelo de Video Wan 2.5',
    
        // Función de integración de audio nativo
        nativeAudioIntegrationTitle: 'Integración de Audio Nativo',
        nativeAudioIntegrationDescription: 'Genera automáticamente sonido, soporta carga de audio personalizado, opcional',
    
        // Función de efectos dinámicos mejorados
        enhancedDynamicEffectsTitle: 'Efectos Dinámicos Mejorados',
        enhancedDynamicEffectsDescription: 'Renderiza acciones complejas con detalles más suaves y naturales',
    
        // Función de control preciso de cámara
        preciseCameraControlTitle: 'Control Preciso de Cámara',
        preciseCameraControlDescription: 'Proporciona mayor ancho de banda para producción de video cinematográfico.',
    
        // Función de realismo visual mejorado
        enhancedVisualRealismTitle: 'Realismo Visual Mejorado',
        enhancedVisualRealismDescription: 'Composición de escenas más rica y refinada',
    
        // Función de comprensión de contexto mejorada
        improvedContextUnderstandingTitle: 'Comprensión de Contexto Mejorada',
        improvedContextUnderstandingDescription: 'Interpreta mejor acciones complejas de personajes y guía de escenas creativas.',
    
        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Wan 2.5',
        step1Description: 'Ve a la página "Generación de Video IA", luego haz clic en "Wan 2.5" en el menú desplegable de modelos.',
        step1DescriptionHighlight: 'Generación de Video IA',
        step2Title: 'Introduce Tu Contenido Creativo',
        step2Description: 'Describe el contenido que deseas generar, o sube imágenes para conversión, y ajusta las configuraciones de parámetros relevantes.',
        step3Title: 'Descarga Tu Video',
        step3Description: 'Haz clic en "Crear" para descargar o compartir libremente el video de alta calidad generado.',
    
        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Video Wan 2.5',
    
        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones Populares de X sobre el Modelo de Video IA Wan 2.5',
    
        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        runwayTitle: 'Generador de Video IA Runway',
        veo31Title: 'Generador de Video IA Google Veo 3.1',
        seedanceTitle: 'Generador de Video Seedance 1.0 Pro',
    
        // Sección FAQ
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es Wan 2.5?',
        faq1Answer: 'Wan 2.5 es una plataforma avanzada de generación de video IA enfocada en creación de video de alta calidad y expresión creativa. Soporta múltiples modos de generación de video y puede generar hermoso contenido de video basado en descripciones de texto o entradas de imagen.',
        faq2Question: '¿Cuáles son las características principales de Wan 2.5?',
        faq2Answer: 'Las características principales de Wan 2.5 incluyen: generación de video de alta calidad, soporte de expresión creativa, soporte de entrada multimodal, opciones de control avanzadas, etc. Puede generar contenido de video de alta resolución y rico en detalles, y soporta varios estilos artísticos y métodos de expresión creativa.',
        faq3Question: '¿Puedo usar Wan 2.5 gratis?',
        faq3Answer: 'Sí. Wan 2.5 proporciona créditos gratuitos limitados a través de la prueba gratuita de 微鲤AI. Para uso extensivo, se requiere una actualización.',
        faq4Question: '¿Qué métodos de entrada soporta Wan 2.5?',
        faq4Answer: 'Wan 2.5 soporta múltiples métodos de entrada, incluyendo descripciones de texto, entradas de imagen, audio, etc. Este soporte de entrada multimodal le permite expresar y realizar ideas creativas a través de diferentes medios.',
        faq5Question: '¿Puedo usar Wan 2.5 para proyectos profesionales o comerciales?',
        faq5Answer: 'Sí. Las capacidades de generación de video de alta calidad y expresión creativa poderosa de Wan 2.5 lo convierten en una opción sólida para productores de video profesionales, creadores de contenido y usuarios comerciales.',
    
        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Wan 2.5 ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Wan 2.5 en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    
        // Relacionado con reproducción de video
        videoNotSupported: 'Su navegador no soporta reproducción de video',
        videoLoadingError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle: 'Générateur de Vidéo Wan 2.5 - Plateforme Avancée de Création Vidéo IA',
        pageDescription: 'Découvrez le générateur de vidéo Wan 2.5 axé sur la création vidéo de haute qualité et l\'expression créative. Prend en charge plusieurs modes de génération vidéo pour créer du contenu vidéo magnifique basé sur des descriptions textuelles ou des entrées d\'image. Essayez-le gratuitement sur la plateforme 微鲤AI.',
        pageKeywords: 'Wan 2.5, générateur de vidéo IA, création vidéo IA, vidéo intelligence artificielle, outil de génération vidéo, vidéo IA gratuite, 微鲤AI, production vidéo',
    
        // Section du générateur
        generatorTitle: 'Générateur de Vidéo Wan 2.5',
        generatorDescription: 'Wan 2.5 est un outil avancé de génération d\'images et de vidéos IA lancé par le géant chinois du commerce électronique Alibaba, qui a récemment annoncé des plans pour investir plus de 50 milliards de dollars dans le cloud computing et l\'intelligence artificielle. Son',
        generatorDescriptionHighlight1: 'modèle Wan 2.5 est maintenant intégré au générateur de vidéo 微鲤AI et peut générer des vidéos réalistes',
        generatorDescriptionText2: '. Cliquez ici pour',
        generatorDescriptionHighlight2: 'essayer Wan 2.5 gratuitement',
        generatorDescriptionEnd: ' !',
        
        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',
    
        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales du Modèle Vidéo Wan 2.5',
    
        // Fonction d'intégration audio native
        nativeAudioIntegrationTitle: 'Intégration Audio Native',
        nativeAudioIntegrationDescription: 'Génère automatiquement du son, prend en charge le téléchargement audio personnalisé, optionnel',
    
        // Fonction d'effets dynamiques améliorés
        enhancedDynamicEffectsTitle: 'Effets Dynamiques Améliorés',
        enhancedDynamicEffectsDescription: 'Rend des actions complexes avec des détails plus fluides et naturels',
    
        // Fonction de contrôle précis de la caméra
        preciseCameraControlTitle: 'Contrôle Précis de la Caméra',
        preciseCameraControlDescription: 'Fournit une plus grande bande passante pour la production vidéo cinématographique.',
    
        // Fonction de réalisme visuel amélioré
        enhancedVisualRealismTitle: 'Réalisme Visuel Amélioré',
        enhancedVisualRealismDescription: 'Composition de scène plus riche et raffinée',
    
        // Fonction de compréhension du contexte améliorée
        improvedContextUnderstandingTitle: 'Compréhension du Contexte Améliorée',
        improvedContextUnderstandingDescription: 'Interprète mieux les actions complexes des personnages et les directives de scènes créatives.',
    
        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Wan 2.5',
        step1Description: 'Allez à la page "Génération Vidéo IA", puis cliquez sur "Wan 2.5" dans le menu déroulant des modèles.',
        step1DescriptionHighlight: 'Génération Vidéo IA',
        step2Title: 'Saisissez Votre Contenu Créatif',
        step2Description: 'Décrivez le contenu que vous souhaitez générer, ou téléchargez des images pour la conversion, et ajustez les paramètres pertinents.',
        step3Title: 'Téléchargez Votre Vidéo',
        step3Description: 'Cliquez sur "Créer" pour télécharger ou partager librement la vidéo de haute qualité générée.',
    
        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle Vidéo Wan 2.5',
    
        // Section publications X
        xPostsTitle: 'Publications X Populaires sur le Modèle Vidéo IA Wan 2.5',
    
        // Section explorer d'autres modèles
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        sora2Title: 'Générateur de Vidéo IA OpenAI Sora-2',
        runwayTitle: 'Générateur de Vidéo IA Runway',
        veo31Title: 'Générateur de Vidéo IA Google Veo 3.1',
        seedanceTitle: 'Générateur de Vidéo Seedance 1.0 Pro',
    
        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Qu\'est-ce que Wan 2.5 ?',
        faq1Answer: 'Wan 2.5 est une plateforme avancée de génération vidéo IA axée sur la création vidéo de haute qualité et l\'expression créative. Elle prend en charge plusieurs modes de génération vidéo et peut générer du contenu vidéo magnifique basé sur des descriptions textuelles ou des entrées d\'image.',
        faq2Question: 'Quelles sont les principales fonctionnalités de Wan 2.5 ?',
        faq2Answer: 'Les principales fonctionnalités de Wan 2.5 incluent : génération vidéo de haute qualité, support d\'expression créative, support d\'entrée multimodale, options de contrôle avancées, etc. Il peut générer du contenu vidéo haute résolution et riche en détails, et prend en charge divers styles artistiques et méthodes d\'expression créative.',
        faq3Question: 'Puis-je utiliser Wan 2.5 gratuitement ?',
        faq3Answer: 'Oui. Wan 2.5 fournit des crédits gratuits limités via l\'essai gratuit de 微鲤AI. Pour une utilisation extensive, une mise à niveau est nécessaire.',
        faq4Question: 'Quelles méthodes d\'entrée Wan 2.5 prend-il en charge ?',
        faq4Answer: 'Wan 2.5 prend en charge plusieurs méthodes d\'entrée, y compris les descriptions textuelles, les entrées d\'image, l\'audio, etc. Ce support d\'entrée multimodale vous permet d\'exprimer et de réaliser des idées créatives à travers différents médias.',
        faq5Question: 'Puis-je utiliser Wan 2.5 pour des projets professionnels ou commerciaux ?',
        faq5Answer: 'Oui. Les capacités de génération vidéo de haute qualité et d\'expression créative puissante de Wan 2.5 en font un choix solide pour les producteurs vidéo professionnels, les créateurs de contenu et les utilisateurs commerciaux.',
    
        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Wan 2.5 maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Wan 2.5 sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    
        // Lié à la lecture vidéo
        videoNotSupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle: 'Wan 2.5 Videogenerator - Fortgeschrittene KI-Videoerstellungsplattform',
        pageDescription: 'Erleben Sie den Wan 2.5 Videogenerator, der sich auf hochwertige Videoerstellung und kreativen Ausdruck konzentriert. Unterstützt mehrere Videogenerierungsmodi zur Erstellung schöner Videoinhalte basierend auf Textbeschreibungen oder Bildeingaben. Kostenlos auf der 微鲤AI-Plattform testen.',
        pageKeywords: 'Wan 2.5, KI-Videogenerator, KI-Videoerstellung, künstliche Intelligenz Video, Videogenerierungs-Tool, kostenloses KI-Video, 微鲤AI, Videoproduktion',
    
        // Generator-Abschnitt
        generatorTitle: 'Wan 2.5 Videogenerator',
        generatorDescription: 'Wan 2.5 ist ein fortschrittliches KI-Bild- und Videogenerierungs-Tool, das vom chinesischen E-Commerce-Riesen Alibaba eingeführt wurde, der kürzlich Pläne angekündigt hat, über 50 Milliarden Dollar in Cloud Computing und künstliche Intelligenz zu investieren. Sein',
        generatorDescriptionHighlight1: 'Wan 2.5 Modell ist jetzt in den 微鲤AI Videogenerator integriert und kann realistische Videos generieren',
        generatorDescriptionText2: '. Klicken Sie hier, um',
        generatorDescriptionHighlight2: 'Wan 2.5 kostenlos zu testen',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',
    
        // Kernfunktionen-Abschnitt
        coreFeaturesTitle: 'Hauptfunktionen des Wan 2.5 Videomodells',
    
        // Native Audiointegrationsfunktion
        nativeAudioIntegrationTitle: 'Native Audiointegration',
        nativeAudioIntegrationDescription: 'Generiert automatisch Ton, unterstützt benutzerdefinierten Audio-Upload, optional',
    
        // Erweiterte dynamische Effekte-Funktion
        enhancedDynamicEffectsTitle: 'Erweiterte Dynamische Effekte',
        enhancedDynamicEffectsDescription: 'Rendert komplexe Aktionen mit flüssigeren und natürlicheren Details',
    
        // Präzise Kamerasteuerungsfunktion
        preciseCameraControlTitle: 'Präzise Kamerasteuerung',
        preciseCameraControlDescription: 'Bietet größere Bandbreite für filmische Videoproduktion.',
    
        // Verbesserter visueller Realismus-Funktion
        enhancedVisualRealismTitle: 'Verbesserter Visueller Realismus',
        enhancedVisualRealismDescription: 'Reichhaltigere und raffiniertere Szenenkompositionen',
    
        // Verbesserte Kontextverständnis-Funktion
        improvedContextUnderstandingTitle: 'Verbessertes Kontextverständnis',
        improvedContextUnderstandingDescription: 'Interpretiert komplexe Charakteraktionen und kreative Szenenanleitung besser.',
    
        // Wie zu verwenden-Abschnitt
        howToUseTitle: 'Wie Man Verwendet',
        step1Title: 'Wan 2.5 Modell Auswählen',
        step1Description: 'Gehen Sie zur Seite "KI-Videogenerierung" und klicken Sie dann auf "Wan 2.5" im Modell-Dropdown-Menü.',
        step1DescriptionHighlight: 'KI-Videogenerierung',
        step2Title: 'Geben Sie Ihren Kreativen Inhalt Ein',
        step2Description: 'Beschreiben Sie den Inhalt, den Sie generieren möchten, oder laden Sie Bilder zur Konvertierung hoch und passen Sie die relevanten Parametereinstellungen an.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description: 'Klicken Sie auf "Erstellen", um das generierte hochwertige Video frei herunterzuladen oder zu teilen.',
    
        // YouTube-Videos-Abschnitt
        youtubeTitle: 'YouTube-Videos über das Wan 2.5 Videomodell',
    
        // X-Beiträge-Abschnitt
        xPostsTitle: 'Beliebte X-Beiträge über das Wan 2.5 KI-Videomodell',
    
        // Andere Modelle erkunden-Abschnitt
        exploreModelsTitle: 'Andere Modelle Erkunden',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        runwayTitle: 'Runway KI-Videogenerator',
        veo31Title: 'Google Veo 3.1 KI-Videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro Videogenerator',
    
        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist Wan 2.5?',
        faq1Answer: 'Wan 2.5 ist eine fortschrittliche KI-Videogenerierungsplattform, die sich auf hochwertige Videoerstellung und kreativen Ausdruck konzentriert. Sie unterstützt mehrere Videogenerierungsmodi und kann schönen Videoinhalt basierend auf Textbeschreibungen oder Bildeingaben generieren.',
        faq2Question: 'Was sind die Hauptfunktionen von Wan 2.5?',
        faq2Answer: 'Die Hauptfunktionen von Wan 2.5 umfassen: hochwertige Videogenerierung, Unterstützung für kreativen Ausdruck, multimodale Eingabeunterstützung, erweiterte Steuerungsoptionen usw. Es kann hochauflösenden, detailreichen Videoinhalt generieren und unterstützt verschiedene künstlerische Stile und kreative Ausdrucksmethoden.',
        faq3Question: 'Kann ich Wan 2.5 kostenlos verwenden?',
        faq3Answer: 'Ja. Wan 2.5 bietet begrenzte kostenlose Credits über die kostenlose Testversion von 微鲤AI. Für umfangreiche Nutzung ist ein Upgrade erforderlich.',
        faq4Question: 'Welche Eingabemethoden unterstützt Wan 2.5?',
        faq4Answer: 'Wan 2.5 unterstützt mehrere Eingabemethoden, einschließlich Textbeschreibungen, Bildeingaben, Audio usw. Diese multimodale Eingabeunterstützung ermöglicht es Ihnen, kreative Ideen durch verschiedene Medien auszudrücken und zu realisieren.',
        faq5Question: 'Kann ich Wan 2.5 für professionelle oder kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. Wan 2.5s hochwertige Videogenerierung und leistungsstarke kreative Ausdrucksfähigkeiten machen es zu einer soliden Wahl für professionelle Videoproduzenten, Content-Ersteller und kommerzielle Benutzer.',
    
        // CTA-Abschnitt
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Wan 2.5 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Testen Sie Wan 2.5 auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    
        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadingError: 'Videoladen fehlgeschlagen',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle: 'Генератор видео Wan 2.5 - Продвинутая платформа создания видео с ИИ',
        pageDescription: 'Испытайте генератор видео Wan 2.5, ориентированный на создание высококачественного видео и творческое выражение. Поддерживает несколько режимов генерации видео для создания красивого видеоконтента на основе текстовых описаний или изображений. Попробуйте бесплатно на платформе 微鲤AI.',
        pageKeywords: 'Wan 2.5, генератор видео ИИ, создание видео ИИ, видео искусственного интеллекта, инструмент генерации видео, бесплатное видео ИИ, 微鲤AI, производство видео',
    
        // Раздел генератора
        generatorTitle: 'Генератор видео Wan 2.5',
        generatorDescription: 'Wan 2.5 - это продвинутый инструмент генерации изображений и видео с ИИ, запущенный китайским гигантом электронной коммерции Alibaba, который недавно объявил о планах инвестировать более 50 миллиардов долларов в облачные вычисления и искусственный интеллект. Его',
        generatorDescriptionHighlight1: 'модель Wan 2.5 теперь интегрирована в генератор видео 微鲤AI и может генерировать реалистичные видео',
        generatorDescriptionText2: '. Нажмите здесь, чтобы',
        generatorDescriptionHighlight2: 'попробовать Wan 2.5 бесплатно',
        generatorDescriptionEnd: '!',
        
        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',
    
        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции видеомодели Wan 2.5',
    
        // Функция встроенной аудиоинтеграции
        nativeAudioIntegrationTitle: 'Встроенная интеграция аудио',
        nativeAudioIntegrationDescription: 'Автоматически генерирует звук, поддерживает загрузку пользовательского аудио, опционально',
    
        // Функция улучшенных динамических эффектов
        enhancedDynamicEffectsTitle: 'Улучшенные динамические эффекты',
        enhancedDynamicEffectsDescription: 'Рендерит сложные действия с более плавными и естественными деталями',
    
        // Функция точного управления камерой
        preciseCameraControlTitle: 'Точное управление камерой',
        preciseCameraControlDescription: 'Обеспечивает большую пропускную способность для кинематографического производства видео.',
    
        // Функция улучшенного визуального реализма
        enhancedVisualRealismTitle: 'Улучшенный визуальный реализм',
        enhancedVisualRealismDescription: 'Более богатая и утонченная композиция сцен',
    
        // Функция улучшенного понимания контекста
        improvedContextUnderstandingTitle: 'Улучшенное понимание контекста',
        improvedContextUnderstandingDescription: 'Лучше интерпретирует сложные действия персонажей и творческое руководство сценами.',
    
        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        step1Title: 'Выберите модель Wan 2.5',
        step1Description: 'Перейдите на страницу "Генерация видео с ИИ", затем нажмите "Wan 2.5" в выпадающем меню моделей.',
        step1DescriptionHighlight: 'Генерация видео с ИИ',
        step2Title: 'Введите ваш творческий контент',
        step2Description: 'Опишите контент, который вы хотите сгенерировать, или загрузите изображения для конверсии и настройте соответствующие параметры.',
        step3Title: 'Скачайте ваше видео',
        step3Description: 'Нажмите "Создать", чтобы свободно скачать или поделиться сгенерированным высококачественным видео.',
    
        // Раздел видео на YouTube
        youtubeTitle: 'Видео на YouTube о видеомодели Wan 2.5',
    
        // Раздел постов X
        xPostsTitle: 'Популярные посты X о видеомодели ИИ Wan 2.5',
    
        // Раздел исследования других моделей
        exploreModelsTitle: 'Исследовать другие модели',
        sora2Title: 'Генератор видео ИИ OpenAI Sora-2',
        runwayTitle: 'Генератор видео ИИ Runway',
        veo31Title: 'Генератор видео ИИ Google Veo 3.1',
        seedanceTitle: 'Генератор видео Seedance 1.0 Pro',
    
        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Wan 2.5?',
        faq1Answer: 'Wan 2.5 - это продвинутая платформа генерации видео с ИИ, ориентированная на создание высококачественного видео и творческое выражение. Она поддерживает несколько режимов генерации видео и может создавать красивый видеоконтент на основе текстовых описаний или изображений.',
        faq2Question: 'Каковы основные функции Wan 2.5?',
        faq2Answer: 'Основные функции Wan 2.5 включают: генерацию высококачественного видео, поддержку творческого выражения, поддержку мультимодального ввода, расширенные параметры управления и т.д. Она может генерировать видеоконтент высокого разрешения с богатыми деталями и поддерживает различные художественные стили и методы творческого выражения.',
        faq3Question: 'Могу ли я использовать Wan 2.5 бесплатно?',
        faq3Answer: 'Да. Wan 2.5 предоставляет ограниченные бесплатные кредиты через бесплатную пробную версию 微鲤AI. Для обширного использования требуется обновление.',
        faq4Question: 'Какие методы ввода поддерживает Wan 2.5?',
        faq4Answer: 'Wan 2.5 поддерживает несколько методов ввода, включая текстовые описания, изображения, аудио и т.д. Эта поддержка мультимодального ввода позволяет вам выражать и реализовывать творческие идеи через различные медиа.',
        faq5Question: 'Могу ли я использовать Wan 2.5 для профессиональных или коммерческих проектов?',
        faq5Answer: 'Да. Высококачественная генерация видео и мощные возможности творческого выражения Wan 2.5 делают его надежным выбором для профессиональных видеопродюсеров, создателей контента и коммерческих пользователей.',
    
        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Испытайте Wan 2.5 сейчас и превратите вашу креативность в потрясающие видео',
        ctaButton: 'Попробуйте Wan 2.5 на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    
        // Связанное с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle: 'Gerador de Vídeo Wan 2.5 - Plataforma Avançada de Criação de Vídeo IA',
        pageDescription: 'Experimente o gerador de vídeo Wan 2.5 focado em criação de vídeo de alta qualidade e expressão criativa. Suporta múltiplos modos de geração de vídeo para criar belo conteúdo de vídeo baseado em descrições de texto ou entradas de imagem. Experimente grátis na plataforma 微鲤AI.',
        pageKeywords: 'Wan 2.5, gerador de vídeo IA, criação de vídeo IA, vídeo de inteligência artificial, ferramenta de geração de vídeo, vídeo IA grátis, 微鲤AI, produção de vídeo',
    
        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo Wan 2.5',
        generatorDescription: 'Wan 2.5 é uma ferramenta avançada de geração de imagens e vídeos IA lançada pelo gigante chinês do comércio eletrônico Alibaba, que recentemente anunciou planos para investir mais de US$ 50 bilhões em computação em nuvem e inteligência artificial. Seu',
        generatorDescriptionHighlight1: 'modelo Wan 2.5 agora está integrado ao gerador de vídeo 微鲤AI e pode gerar vídeos realistas',
        generatorDescriptionText2: '. Clique aqui para',
        generatorDescriptionHighlight2: 'experimentar Wan 2.5 grátis',
        generatorDescriptionEnd: '!',
        
        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',
    
        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Modelo de Vídeo Wan 2.5',
    
        // Função de integração de áudio nativo
        nativeAudioIntegrationTitle: 'Integração de Áudio Nativo',
        nativeAudioIntegrationDescription: 'Gera automaticamente som, suporta upload de áudio personalizado, opcional',
    
        // Função de efeitos dinâmicos aprimorados
        enhancedDynamicEffectsTitle: 'Efeitos Dinâmicos Aprimorados',
        enhancedDynamicEffectsDescription: 'Renderiza ações complexas com detalhes mais suaves e naturais',
    
        // Função de controle preciso de câmera
        preciseCameraControlTitle: 'Controle Preciso de Câmera',
        preciseCameraControlDescription: 'Fornece maior largura de banda para produção de vídeo cinematográfico.',
    
        // Função de realismo visual aprimorado
        enhancedVisualRealismTitle: 'Realismo Visual Aprimorado',
        enhancedVisualRealismDescription: 'Composição de cena mais rica e refinada',
    
        // Função de compreensão de contexto melhorada
        improvedContextUnderstandingTitle: 'Compreensão de Contexto Melhorada',
        improvedContextUnderstandingDescription: 'Interpreta melhor ações complexas de personagens e orientação criativa de cenas.',
    
        // Seção como usar
        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Wan 2.5',
        step1Description: 'Vá para a página "Geração de Vídeo IA", depois clique em "Wan 2.5" no menu suspenso de modelos.',
        step1DescriptionHighlight: 'Geração de Vídeo IA',
        step2Title: 'Insira Seu Conteúdo Criativo',
        step2Description: 'Descreva o conteúdo que deseja gerar, ou faça upload de imagens para conversão, e ajuste as configurações de parâmetros relevantes.',
        step3Title: 'Baixe Seu Vídeo',
        step3Description: 'Clique em "Criar" para baixar ou compartilhar livremente o vídeo de alta qualidade gerado.',
    
        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo Wan 2.5',
    
        // Seção de publicações X
        xPostsTitle: 'Publicações Populares do X sobre o Modelo de Vídeo IA Wan 2.5',
    
        // Seção explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        runwayTitle: 'Gerador de Vídeo IA Runway',
        veo31Title: 'Gerador de Vídeo IA Google Veo 3.1',
        seedanceTitle: 'Gerador de Vídeo Seedance 1.0 Pro',
    
        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é Wan 2.5?',
        faq1Answer: 'Wan 2.5 é uma plataforma avançada de geração de vídeo IA focada em criação de vídeo de alta qualidade e expressão criativa. Suporta múltiplos modos de geração de vídeo e pode gerar belo conteúdo de vídeo baseado em descrições de texto ou entradas de imagem.',
        faq2Question: 'Quais são os recursos principais do Wan 2.5?',
        faq2Answer: 'Os recursos principais do Wan 2.5 incluem: geração de vídeo de alta qualidade, suporte de expressão criativa, suporte de entrada multimodal, opções de controle avançadas, etc. Pode gerar conteúdo de vídeo de alta resolução e rico em detalhes, e suporta vários estilos artísticos e métodos de expressão criativa.',
        faq3Question: 'Posso usar o Wan 2.5 gratuitamente?',
        faq3Answer: 'Sim. O Wan 2.5 fornece créditos gratuitos limitados através do teste gratuito do 微鲤AI. Para uso extensivo, é necessária uma atualização.',
        faq4Question: 'Quais métodos de entrada o Wan 2.5 suporta?',
        faq4Answer: 'O Wan 2.5 suporta múltiplos métodos de entrada, incluindo descrições de texto, entradas de imagem, áudio, etc. Este suporte de entrada multimodal permite que você expresse e realize ideias criativas através de diferentes mídias.',
        faq5Question: 'Posso usar o Wan 2.5 para projetos profissionais ou comerciais?',
        faq5Answer: 'Sim. As capacidades de geração de vídeo de alta qualidade e expressão criativa poderosa do Wan 2.5 o tornam uma escolha sólida para produtores de vídeo profissionais, criadores de conteúdo e usuários comerciais.',
    
        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Wan 2.5 agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente o Wan 2.5 no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    
        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle: 'Generatore di Video Wan 2.5 - Piattaforma Avanzata di Creazione Video IA',
        pageDescription: 'Scopri il generatore di video Wan 2.5 focalizzato sulla creazione di video di alta qualità e sull\'espressione creativa. Supporta più modalità di generazione video per creare splendidi contenuti video basati su descrizioni testuali o input di immagini. Provalo gratuitamente sulla piattaforma 微鲤AI.',
        pageKeywords: 'Wan 2.5, generatore video IA, creazione video IA, video intelligenza artificiale, strumento generazione video, video IA gratuito, 微鲤AI, produzione video',
    
        // Sezione generatore
        generatorTitle: 'Generatore di Video Wan 2.5',
        generatorDescription: 'Wan 2.5 è uno strumento avanzato di generazione di immagini e video IA lanciato dal gigante cinese dell\'e-commerce Alibaba, che ha recentemente annunciato piani per investire oltre 50 miliardi di dollari in cloud computing e intelligenza artificiale. Il suo',
        generatorDescriptionHighlight1: 'modello Wan 2.5 è ora integrato nel generatore video 微鲤AI e può generare video realistici',
        generatorDescriptionText2: '. Clicca qui per',
        generatorDescriptionHighlight2: 'provare Wan 2.5 gratuitamente',
        generatorDescriptionEnd: '!',
        
        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',
    
        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali del Modello Video Wan 2.5',
    
        // Funzione integrazione audio nativa
        nativeAudioIntegrationTitle: 'Integrazione Audio Nativa',
        nativeAudioIntegrationDescription: 'Genera automaticamente suono, supporta caricamento audio personalizzato, opzionale',
    
        // Funzione effetti dinamici migliorati
        enhancedDynamicEffectsTitle: 'Effetti Dinamici Migliorati',
        enhancedDynamicEffectsDescription: 'Renderizza azioni complesse con dettagli più fluidi e naturali',
    
        // Funzione controllo preciso della fotocamera
        preciseCameraControlTitle: 'Controllo Preciso della Fotocamera',
        preciseCameraControlDescription: 'Fornisce maggiore larghezza di banda per la produzione video cinematografica.',
    
        // Funzione realismo visivo migliorato
        enhancedVisualRealismTitle: 'Realismo Visivo Migliorato',
        enhancedVisualRealismDescription: 'Composizione di scene più ricca e raffinata',
    
        // Funzione comprensione del contesto migliorata
        improvedContextUnderstandingTitle: 'Comprensione del Contesto Migliorata',
        improvedContextUnderstandingDescription: 'Interpreta meglio azioni complesse dei personaggi e guida creativa delle scene.',
    
        // Sezione come usare
        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona Modello Wan 2.5',
        step1Description: 'Vai alla pagina "Generazione Video IA", quindi clicca su "Wan 2.5" nel menu a discesa dei modelli.',
        step1DescriptionHighlight: 'Generazione Video IA',
        step2Title: 'Inserisci il Tuo Contenuto Creativo',
        step2Description: 'Descrivi il contenuto che vuoi generare, o carica immagini per la conversione, e regola le impostazioni dei parametri rilevanti.',
        step3Title: 'Scarica il Tuo Video',
        step3Description: 'Clicca su "Crea" per scaricare o condividere liberamente il video di alta qualità generato.',
    
        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello Video Wan 2.5',
    
        // Sezione post X
        xPostsTitle: 'Post X Popolari sul Modello Video IA Wan 2.5',
    
        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli',
        sora2Title: 'Generatore Video IA OpenAI Sora-2',
        runwayTitle: 'Generatore Video IA Runway',
        veo31Title: 'Generatore Video IA Google Veo 3.1',
        seedanceTitle: 'Generatore Video Seedance 1.0 Pro',
    
        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Cos\'è Wan 2.5?',
        faq1Answer: 'Wan 2.5 è una piattaforma avanzata di generazione video IA focalizzata sulla creazione di video di alta qualità e sull\'espressione creativa. Supporta più modalità di generazione video e può generare splendidi contenuti video basati su descrizioni testuali o input di immagini.',
        faq2Question: 'Quali sono le caratteristiche principali di Wan 2.5?',
        faq2Answer: 'Le caratteristiche principali di Wan 2.5 includono: generazione video di alta qualità, supporto per espressione creativa, supporto input multimodale, opzioni di controllo avanzate, ecc. Può generare contenuti video ad alta risoluzione e ricchi di dettagli e supporta vari stili artistici e metodi di espressione creativa.',
        faq3Question: 'Posso usare Wan 2.5 gratuitamente?',
        faq3Answer: 'Sì. Wan 2.5 fornisce crediti gratuiti limitati attraverso la prova gratuita di 微鲤AI. Per un uso estensivo, è necessario un upgrade.',
        faq4Question: 'Quali metodi di input supporta Wan 2.5?',
        faq4Answer: 'Wan 2.5 supporta più metodi di input, tra cui descrizioni testuali, input di immagini, audio, ecc. Questo supporto input multimodale ti consente di esprimere e realizzare idee creative attraverso diversi media.',
        faq5Question: 'Posso usare Wan 2.5 per progetti professionali o commerciali?',
        faq5Answer: 'Sì. Le capacità di generazione video di alta qualità e potente espressione creativa di Wan 2.5 lo rendono una scelta solida per produttori video professionali, creatori di contenuti e utenti commerciali.',
    
        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Prova Wan 2.5 ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Wan 2.5 su 微鲤AI',
        ctaDisclaimer: 'Non è richiesta la carta di credito',
    
        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Caricamento video fallito',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle: 'مولد الفيديو Wan 2.5 - منصة إنشاء فيديو ذكاء اصطناعي متقدمة',
        pageDescription: 'جرب مولد الفيديو Wan 2.5 المركز على إنشاء فيديو عالي الجودة والتعبير الإبداعي. يدعم أنماط توليد فيديو متعددة لإنشاء محتوى فيديو جميل بناءً على أوصاف نصية أو مدخلات صور. جربه مجانًا على منصة 微鲤AI.',
        pageKeywords: 'Wan 2.5, مولد فيديو ذكاء اصطناعي, إنشاء فيديو ذكاء اصطناعي, فيديو ذكاء اصطناعي, أداة توليد فيديو, فيديو ذكاء اصطناعي مجاني, 微鲤AI, إنتاج فيديو',
    
        // قسم المولد
        generatorTitle: 'مولد الفيديو Wan 2.5',
        generatorDescription: 'Wan 2.5 هي أداة متقدمة لتوليد الصور والفيديو بالذكاء الاصطناعي أطلقها عملاق التجارة الإلكترونية الصيني Alibaba، الذي أعلن مؤخرًا عن خطط للاستثمار بأكثر من 50 مليار دولار في الحوسبة السحابية والذكاء الاصطناعي. إن',
        generatorDescriptionHighlight1: 'نموذج Wan 2.5 مدمج الآن في مولد الفيديو 微鲤AI ويمكنه توليد مقاطع فيديو واقعية',
        generatorDescriptionText2: '. انقر هنا',
        generatorDescriptionHighlight2: 'لتجربة Wan 2.5 مجانًا',
        generatorDescriptionEnd: '!',
        
        // التبويبات
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',
    
        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لنموذج الفيديو Wan 2.5',
    
        // وظيفة تكامل الصوت الأصلي
        nativeAudioIntegrationTitle: 'تكامل الصوت الأصلي',
        nativeAudioIntegrationDescription: 'يولد الصوت تلقائيًا، يدعم تحميل صوت مخصص، اختياري',
    
        // وظيفة التأثيرات الديناميكية المحسنة
        enhancedDynamicEffectsTitle: 'تأثيرات ديناميكية محسنة',
        enhancedDynamicEffectsDescription: 'يعرض إجراءات معقدة بتفاصيل أكثر سلاسة وطبيعية',
    
        // وظيفة التحكم الدقيق في الكاميرا
        preciseCameraControlTitle: 'تحكم دقيق في الكاميرا',
        preciseCameraControlDescription: 'يوفر نطاقًا تردديًا أكبر لإنتاج الفيديو السينمائي.',
    
        // وظيفة الواقعية البصرية المحسنة
        enhancedVisualRealismTitle: 'واقعية بصرية محسنة',
        enhancedVisualRealismDescription: 'تكوين مشهد أكثر ثراءً ودقة',
    
        // وظيفة الفهم السياقي المحسن
        improvedContextUnderstandingTitle: 'فهم سياقي محسن',
        improvedContextUnderstandingDescription: 'يفسر بشكل أفضل الإجراءات المعقدة للشخصيات وتوجيه المشاهد الإبداعية.',
    
        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'اختر نموذج Wan 2.5',
        step1Description: 'انتقل إلى صفحة "توليد الفيديو بالذكاء الاصطناعي"، ثم انقر على "Wan 2.5" في القائمة المنسدلة للنماذج.',
        step1DescriptionHighlight: 'توليد الفيديو بالذكاء الاصطناعي',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description: 'صف المحتوى الذي تريد توليده، أو قم بتحميل صور للتحويل، واضبط إعدادات المعاملات ذات الصلة.',
        step3Title: 'قم بتنزيل الفيديو الخاص بك',
        step3Description: 'انقر على "إنشاء" لتنزيل أو مشاركة الفيديو عالي الجودة المُنشأ بحرية.',
    
        // قسم فيديوهات YouTube
        youtubeTitle: 'فيديوهات YouTube حول نموذج الفيديو Wan 2.5',
    
        // قسم منشورات X
        xPostsTitle: 'منشورات X الشائعة حول نموذج الفيديو بالذكاء الاصطناعي Wan 2.5',
    
        // قسم استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        sora2Title: 'مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2',
        runwayTitle: 'مولد الفيديو بالذكاء الاصطناعي Runway',
        veo31Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        seedanceTitle: 'مولد الفيديو Seedance 1.0 Pro',
    
        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Wan 2.5؟',
        faq1Answer: 'Wan 2.5 هي منصة متقدمة لتوليد الفيديو بالذكاء الاصطناعي تركز على إنشاء فيديو عالي الجودة والتعبير الإبداعي. تدعم أنماط توليد فيديو متعددة ويمكنها إنشاء محتوى فيديو جميل بناءً على أوصاف نصية أو مدخلات صور.',
        faq2Question: 'ما هي الميزات الرئيسية لـ Wan 2.5؟',
        faq2Answer: 'تشمل الميزات الرئيسية لـ Wan 2.5: توليد فيديو عالي الجودة، دعم التعبير الإبداعي، دعم الإدخال متعدد الوسائط، خيارات التحكم المتقدمة، إلخ. يمكنه إنشاء محتوى فيديو عالي الدقة وغني بالتفاصيل، ويدعم أنماط فنية مختلفة وطرق تعبير إبداعي.',
        faq3Question: 'هل يمكنني استخدام Wan 2.5 مجانًا؟',
        faq3Answer: 'نعم. يوفر Wan 2.5 أرصدة مجانية محدودة من خلال الإصدار التجريبي المجاني من 微鲤AI. للاستخدام المكثف، يلزم الترقية.',
        faq4Question: 'ما طرق الإدخال التي يدعمها Wan 2.5؟',
        faq4Answer: 'يدعم Wan 2.5 طرق إدخال متعددة، بما في ذلك الأوصاف النصية ومدخلات الصور والصوت وغيرها. يتيح لك دعم الإدخال متعدد الوسائط هذا التعبير عن الأفكار الإبداعية وتحقيقها من خلال وسائط مختلفة.',
        faq5Question: 'هل يمكنني استخدام Wan 2.5 للمشاريع الاحترافية أو التجارية؟',
        faq5Answer: 'نعم. تجعل قدرات توليد الفيديو عالية الجودة والتعبير الإبداعي القوي لـ Wan 2.5 خيارًا قويًا لمنتجي الفيديو المحترفين ومنشئي المحتوى والمستخدمين التجاريين.',
    
        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Wan 2.5 الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Wan 2.5 على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
    
        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle: 'เครื่องมือสร้างวิดีโอ Wan 2.5 - แพลตฟอร์มสร้างวิดีโอ AI ขั้นสูง',
        pageDescription: 'สัมผัสเครื่องมือสร้างวิดีโอ Wan 2.5 ที่เน้นการสร้างวิดีโอคุณภาพสูงและการแสดงออกเชิงสร้างสรรค์ รองรับหลายโหมดการสร้างวิดีโอจากคำอธิบายข้อความหรือภาพ ลองฟรีบน 微鲤AI',
        pageKeywords: 'Wan 2.5, เครื่องมือสร้างวิดีโอ AI, การสร้างวิดีโอ AI, วิดีโอปัญญาประดิษฐ์, เครื่องมือสร้างวิดีโอ, วิดีโอ AI ฟรี, 微鲤AI, การผลิตวิดีโอ',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ Wan 2.5',
        generatorDescription: 'Wan 2.5 คือเครื่องมือสร้างภาพและวิดีโอ AI ขั้นสูงที่เปิดตัวโดยยักษ์ใหญ่อีคอมเมิร์ซจีน Alibaba ซึ่งเพิ่งประกาศแผนลงทุนกว่า 50,000 ล้านดอลลาร์ในคลาวด์คอมพิวติ้งและปัญญาประดิษฐ์',
        generatorDescriptionHighlight1: 'โมเดล Wan 2.5 ได้ถูกรวมเข้ากับเครื่องมือสร้างวิดีโอ 微鲤AI และสามารถสร้างวิดีโอที่สมจริง',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'ลอง Wan 2.5 ฟรี',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'คุณสมบัติหลักของโมเดลวิดีโอ Wan 2.5',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'การผสานเสียงแบบเนทีฟ',
        nativeAudioIntegrationDescription: 'สร้างเสียงอัตโนมัติ รองรับการอัปโหลดเสียงเอง แบบเลือกได้',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'เอฟเฟกต์ไดนามิกที่ดีขึ้น',
        enhancedDynamicEffectsDescription: 'เรนเดอร์การเคลื่อนไหวซับซ้อนได้ลื่นไหลและเป็นธรรมชาติมากขึ้น',

        // Precise camera control feature
        preciseCameraControlTitle: 'การควบคุมกล้องอย่างแม่นยำ',
        preciseCameraControlDescription: 'ให้ขีดความสามารถมากขึ้นสำหรับการผลิตวิดีโอแบบภาพยนตร์',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'ความสมจริงทางภาพที่มากขึ้น',
        enhancedVisualRealismDescription: 'องค์ประกอบฉากที่ลึกและละเอียดขึ้น',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'ความเข้าใจบริบทที่ดีขึ้น',
        improvedContextUnderstandingDescription: 'ตีความการเคลื่อนไหวตัวละครที่ซับซ้อนและคำแนะนำฉากสร้างสรรค์ได้ดีขึ้น',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        step1Title: 'เลือกโมเดล Wan 2.5',
        step1Description: 'ไปที่หน้า "AI Video Generation" แล้วคลิก "Wan 2.5" ในเมนูดรอปดาวน์ของโมเดล',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'ป้อนเนื้อหาสร้างสรรค์ของคุณ',
        step2Description: 'อธิบายเนื้อหาที่ต้องการสร้าง หรืออัปโหลดภาพเพื่อแปลง และปรับตั้งค่าพารามิเตอร์ที่เกี่ยวข้อง',
        step3Title: 'ดาวน์โหลดวิดีโอของคุณ',
        step3Description: 'คลิก "Create" เพื่อดาวน์โหลดหรือแชร์วิดีโอคุณภาพสูงที่สร้างขึ้นได้อย่างอิสระ',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Wan 2.5',

        // X Posts section
        xPostsTitle: 'โพสต์ยอดนิยมบน X เกี่ยวกับโมเดลวิดีโอ AI Wan 2.5',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลอื่น ๆ',
        sora2Title: 'เครื่องมือสร้างวิดีโอ AI OpenAI Sora-2',
        runwayTitle: 'เครื่องมือสร้างวิดีโอ AI Runway',
        veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        seedanceTitle: 'เครื่องมือสร้างวิดีโอ Seedance 1.0 Pro',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Wan 2.5 คืออะไร?',
        faq1Answer: 'Wan 2.5 คือแพลตฟอร์มสร้างวิดีโอ AI ขั้นสูงที่เน้นการสร้างวิดีโอคุณภาพสูงและการแสดงออกเชิงสร้างสรรค์ รองรับหลายโหมดการสร้างวิดีโอและสามารถสร้างคอนเทนต์วิดีโอสวยงามจากคำอธิบายข้อความหรือภาพ',
        faq2Question: 'คุณสมบัติหลักของ Wan 2.5 คืออะไร?',
        faq2Answer: 'คุณสมบัติหลักของ Wan 2.5 ได้แก่ การสร้างวิดีโอคุณภาพสูง การสนับสนุนการแสดงออกเชิงสร้างสรรค์ การรองรับอินพุตหลายโมดัล ตัวเลือกควบคุมขั้นสูง เป็นต้น สามารถสร้างวิดีโอความละเอียดสูง รายละเอียดแน่น และรองรับสไตล์ศิลปะหลากหลาย',
        faq3Question: 'ฉันใช้ Wan 2.5 ได้ฟรีไหม?',
        faq3Answer: 'ได้ Wan 2.5 มีเครดิตฟรีจำกัดผ่านการทดลองของ 微鲤AI หากใช้งานมากต้องอัปเกรด',
        faq4Question: 'Wan 2.5 รองรับวิธีการป้อนข้อมูลแบบใด?',
        faq4Answer: 'Wan 2.5 รองรับอินพุตหลายแบบ รวมถึงคำอธิบายข้อความ ภาพ เสียง ฯลฯ การรองรับหลายโมดัลนี้ช่วยให้คุณถ่ายทอดและทำให้ไอเดียสร้างสรรค์เป็นจริงได้ผ่านสื่อต่าง ๆ',
        faq5Question: 'สามารถใช้ Wan 2.5 สำหรับงานมืออาชีพหรือเชิงพาณิชย์ได้ไหม?',
        faq5Answer: 'ได้ ความสามารถในการสร้างวิดีโอคุณภาพสูงและการแสดงออกเชิงสร้างสรรค์ที่ทรงพลังของ Wan 2.5 ทำให้เป็นตัวเลือกที่แข็งแกร่งสำหรับผู้ผลิตวิดีโอมืออาชีพ ครีเอเตอร์ และผู้ใช้งานเชิงพาณิชย์',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription: 'ลอง Wan 2.5 ตอนนี้ และเปลี่ยนความคิดสร้างสรรค์เป็นวิดีโอสุดว้าว',
        ctaButton: 'ลอง Wan 2.5 บน 微鲤AI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle: 'Wan 2.5 videogenerator - avanceret AI-videoskabelsesplatform',
        pageDescription: 'Oplev Wan 2.5 videogeneratoren med fokus på video i høj kvalitet og kreativt udtryk. Understøtter flere videomodes og kan generere smukt videoindhold ud fra tekstbeskrivelser eller billedinput. Prøv gratis på 微鲤AI.',
        pageKeywords: 'Wan 2.5, AI-videogenerator, AI-videoskabelse, kunstig intelligens video, videgenereringsværktøj, gratis AI-video, 微鲤AI, videoproduktion',

        // Generator section
        generatorTitle: 'Wan 2.5 videogenerator',
        generatorDescription: 'Wan 2.5 er et avanceret AI-værktøj til billed- og videogenerering lanceret af den kinesiske e-handelsgigant Alibaba, som for nylig annoncerede planer om at investere over 50 mia. USD i cloud computing og kunstig intelligens. Dets',
        generatorDescriptionHighlight1: 'Wan 2.5-model er nu integreret i 微鲤AI-videogeneratoren og kan skabe realistiske videoer',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'prøve Wan 2.5 gratis',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Hovedfunktioner i Wan 2.5 videomodel',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Indbygget lydintegration',
        nativeAudioIntegrationDescription: 'Genererer lyd automatisk, understøtter upload af egen lyd, valgfrit',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Forbedrede dynamiske effekter',
        enhancedDynamicEffectsDescription: 'Gengiver komplekse bevægelser med mere glatte og naturlige detaljer',

        // Precise camera control feature
        preciseCameraControlTitle: 'Præcis kamerakontrol',
        preciseCameraControlDescription: 'Giver større råderum til filmisk videoproduktion.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Forbedret visuel realisme',
        enhancedVisualRealismDescription: 'Rigere og mere raffineret scenekomposition',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Bedre kontekstforståelse',
        improvedContextUnderstandingDescription: 'Fortolker komplekse karakterhandlinger og kreativ scenevejledning bedre.',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        step1Title: 'Vælg Wan 2.5-model',
        step1Description: 'Gå til siden "AI Video Generation", og klik derefter "Wan 2.5" i modeldropdown-menuen.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Indtast dit kreative indhold',
        step2Description: 'Beskriv indholdet du vil generere, eller upload billeder til konvertering, og juster relevante parametre.',
        step3Title: 'Download din video',
        step3Description: 'Klik "Create" for frit at downloade eller dele den genererede video i høj kvalitet.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Wan 2.5 videomodel',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Wan 2.5 AI-videomodel',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre modeller',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er Wan 2.5?',
        faq1Answer: 'Wan 2.5 er en avanceret AI-platform til videogenerering med fokus på video i høj kvalitet og kreativt udtryk. Den understøtter flere videomodes og kan skabe smukt videoindhold ud fra tekstbeskrivelser eller billedinput.',
        faq2Question: 'Hvad er de vigtigste funktioner i Wan 2.5?',
        faq2Answer: 'Wan 2.5\'s vigtigste funktioner omfatter: videogenerering i høj kvalitet, støtte til kreativt udtryk, multimodalt input og avancerede kontrolmuligheder. Den kan generere video i høj opløsning med rige detaljer og understøtter forskellige kunststile og kreative udtryksformer.',
        faq3Question: 'Kan jeg bruge Wan 2.5 gratis?',
        faq3Answer: 'Ja. Wan 2.5 tilbyder begrænsede gratiskreditter via WeryAIs prøveperiode. Ved omfattende brug kræves opgradering.',
        faq4Question: 'Hvilke inputmetoder understøtter Wan 2.5?',
        faq4Answer: 'Wan 2.5 understøtter flere inputmetoder, herunder tekstbeskrivelser, billedinput, lyd m.m. Denne multimodale support gør det muligt at udtrykke og realisere kreative ideer gennem forskellige medier.',
        faq5Question: 'Kan jeg bruge Wan 2.5 til professionelle eller kommercielle projekter?',
        faq5Answer: 'Ja. Wan 2.5\'s videogenerering i høj kvalitet og stærke kreative muligheder gør den til et godt valg for professionelle videoproducenter, indholdsskabere og kommercielle brugere.',

        // CTA section
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaDescription: 'Prøv Wan 2.5 nu og forvandl din kreativitet til fantastiske videoer',
        ctaButton: 'Prøv Wan 2.5 på 微鲤AI',
        ctaDisclaimer: 'Intet kreditkort kræves',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Indlæsning af video mislykkedes',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle: 'Wan 2.5 videogenerator - avansert AI-videoskapingsplattform',
        pageDescription: 'Opplev Wan 2.5 videogenerator med fokus på høy videokvalitet og kreativt uttrykk. Støtter flere videomodus og kan generere vakkert videoinnhold basert på tekstbeskrivelser eller bildeinput. Prøv gratis på 微鲤AI.',
        pageKeywords: 'Wan 2.5, AI-videogenerator, AI-videoskaping, kunstig intelligens video, videogenereringsverktøy, gratis AI-video, 微鲤AI, videoproduksjon',

        // Generator section
        generatorTitle: 'Wan 2.5 videogenerator',
        generatorDescription: 'Wan 2.5 er et avansert AI-verktøy for bilde- og videogenerering lansert av den kinesiske e-handelsgiganten Alibaba, som nylig annonserte planer om å investere over 50 milliarder dollar i skyplattform og kunstig intelligens. Dets',
        generatorDescriptionHighlight1: 'Wan 2.5-modellen er nå integrert i 微鲤AI-videogeneratoren og kan generere realistiske videoer',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'prøve Wan 2.5 gratis',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Hovedfunksjoner i Wan 2.5 videomodell',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Innebygd lydintegrasjon',
        nativeAudioIntegrationDescription: 'Genererer lyd automatisk, støtter opplasting av egen lyd, valgfritt',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Forbedrede dynamiske effekter',
        enhancedDynamicEffectsDescription: 'Gjengir komplekse handlinger med glattere og mer naturlige detaljer',

        // Precise camera control feature
        preciseCameraControlTitle: 'Presis kamerakontroll',
        preciseCameraControlDescription: 'Gir større spillerom for filmatisk videoproduksjon.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Forbedret visuell realisme',
        enhancedVisualRealismDescription: 'Rikere og mer raffinert scenekomposisjon',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Bedre kontekstforståelse',
        improvedContextUnderstandingDescription: 'Tolker komplekse karakterhandlinger og kreativ sceneveiledning bedre.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        step1Title: 'Velg Wan 2.5-modell',
        step1Description: 'Gå til siden "AI Video Generation", og klikk deretter "Wan 2.5" i modelldropdownen.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Skriv inn ditt kreative innhold',
        step2Description: 'Beskriv innholdet du vil generere, eller last opp bilder for konvertering, og juster relevante parametere.',
        step3Title: 'Last ned videoen din',
        step3Description: 'Klikk "Create" for å laste ned eller dele den genererte videoen i høy kvalitet.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Wan 2.5 videomodell',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Wan 2.5 AI-videomodell',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre modeller',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er Wan 2.5?',
        faq1Answer: 'Wan 2.5 er en avansert AI-videogenereringsplattform med fokus på høy kvalitet og kreativt uttrykk. Den støtter flere videomodus og kan generere vakkert videoinnhold basert på tekstbeskrivelser eller bildeinput.',
        faq2Question: 'Hva er hovedfunksjonene i Wan 2.5?',
        faq2Answer: 'Wan 2.5s hovedfunksjoner inkluderer: videogenerering i høy kvalitet, støtte for kreativt uttrykk, multimodal inputstøtte, avanserte kontrollalternativer m.m. Den kan generere høyoppløselig, detaljrikt videoinnhold og støtter ulike kunststiler og kreative uttrykksformer.',
        faq3Question: 'Kan jeg bruke Wan 2.5 gratis?',
        faq3Answer: 'Ja. Wan 2.5 tilbyr begrensede gratiskreditter via WeryAIs prøveperiode. For omfattende bruk kreves oppgradering.',
        faq4Question: 'Hvilke inputmetoder støtter Wan 2.5?',
        faq4Answer: 'Wan 2.5 støtter flere inputmetoder, inkludert tekstbeskrivelser, bildeinput, lyd osv. Denne multimodale støtten lar deg uttrykke og realisere kreative ideer gjennom ulike medier.',
        faq5Question: 'Kan jeg bruke Wan 2.5 til profesjonelle eller kommersielle prosjekter?',
        faq5Answer: 'Ja. Wan 2.5s høykvalitets videogenerering og sterke kreative uttrykk gjør den til et godt valg for profesjonelle videoprodusenter, innholdsskapere og kommersielle brukere.',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaDescription: 'Prøv Wan 2.5 nå og gjør kreativiteten din om til fantastiske videoer',
        ctaButton: 'Prøv Wan 2.5 på 微鲤AI',
        ctaDisclaimer: 'Ingen kredittkort nødvendig',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Innlasting av video mislyktes',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // Page title and description
        pageTitle: 'Wan 2.5 videogenerator - geavanceerd AI-videoplatform',
        pageDescription: 'Ervaar de Wan 2.5 videogenerator gericht op hoogwaardige videoproductie en creatieve expressie. Ondersteunt meerdere videomodi om mooie video\'s te genereren op basis van tekstbeschrijvingen of beeldinput. Probeer gratis op 微鲤AI.',
        pageKeywords: 'Wan 2.5, AI-videogenerator, AI-videocreatie, kunstmatige intelligentie video, videogeneratie tool, gratis AI-video, 微鲤AI, videoproductie',

        // Generator section
        generatorTitle: 'Wan 2.5 videogenerator',
        generatorDescription: 'Wan 2.5 is een geavanceerde AI-tool voor beeld- en videogeneratie, gelanceerd door de Chinese e-commercegigant Alibaba, die onlangs plannen aankondigde om meer dan 50 miljard dollar te investeren in cloud computing en kunstmatige intelligentie. De',
        generatorDescriptionHighlight1: 'Wan 2.5-model is nu geïntegreerd in de 微鲤AI-videogenerator en kan realistische video\'s maken',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'Wan 2.5 gratis proberen',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Belangrijkste functies van het Wan 2.5-videomodel',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Native audio-integratie',
        nativeAudioIntegrationDescription: 'Genereert automatisch audio, ondersteunt upload van eigen audio, optioneel',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Verbeterde dynamische effecten',
        enhancedDynamicEffectsDescription: 'Rendert complexe acties met vloeiendere en natuurlijkere details',

        // Precise camera control feature
        preciseCameraControlTitle: 'Precieze cameracontrole',
        preciseCameraControlDescription: 'Biedt meer speelruimte voor filmische videoproductie.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Verbeterd visueel realisme',
        enhancedVisualRealismDescription: 'Rijkere en verfijndere scènecompositie',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Verbeterd contextbegrip',
        improvedContextUnderstandingDescription: 'Interpreteert complexe karakteracties en creatieve scène-aanwijzingen beter.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        step1Title: 'Selecteer Wan 2.5-model',
        step1Description: 'Ga naar de pagina "AI Video Generation" en klik vervolgens op "Wan 2.5" in het modelkeuzemenu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Voer je creatieve inhoud in',
        step2Description: 'Beschrijf wat je wilt genereren of upload beelden om te converteren en stel relevante parameters in.',
        step3Title: 'Download je video',
        step3Description: 'Klik op "Create" om de hoogwaardige video vrij te downloaden of te delen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Wan 2.5-videomodel',

        // X Posts section
        xPostsTitle: 'Populaire X-berichten over het Wan 2.5 AI-videomodel',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere modellen',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        seedanceTitle: 'Seedance 1.0 Pro videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is Wan 2.5?',
        faq1Answer: 'Wan 2.5 is een geavanceerd AI-videogeneratieplatform gericht op hoogwaardige videoproductie en creatieve expressie. Het ondersteunt meerdere videomodi en kan prachtige video\'s genereren op basis van tekstbeschrijvingen of beeldinput.',
        faq2Question: 'Wat zijn de belangrijkste functies van Wan 2.5?',
        faq2Answer: 'De belangrijkste functies van Wan 2.5 zijn onder andere: hoogwaardige videogeneratie, ondersteuning voor creatieve expressie, multimodale input en geavanceerde controle-opties. Het kan video\'s met hoge resolutie en rijke details genereren en ondersteunt verschillende artistieke stijlen en creatieve expressievormen.',
        faq3Question: 'Kan ik Wan 2.5 gratis gebruiken?',
        faq3Answer: 'Ja. Wan 2.5 biedt beperkte gratis credits via 微鲤AI\'s proefperiode. Voor intensief gebruik is een upgrade nodig.',
        faq4Question: 'Welke inputmethoden ondersteunt Wan 2.5?',
        faq4Answer: 'Wan 2.5 ondersteunt meerdere inputmethoden, waaronder tekstbeschrijvingen, beeldinput, audio, enz. Deze multimodale ondersteuning stelt je in staat creatieve ideeën te uiten en te realiseren via verschillende media.',
        faq5Question: 'Kan ik Wan 2.5 gebruiken voor professionele of commerciële projecten?',
        faq5Answer: 'Ja. Wan 2.5\'s hoogwaardige videogeneratie en krachtige creatieve expressie maken het een sterke keuze voor professionele videoproducenten, content creators en commerciële gebruikers.',

        // CTA section
        ctaTitle: 'Klaar om te beginnen?',
        ctaDescription: 'Ervaar Wan 2.5 nu en zet je creativiteit om in geweldige video\'s',
        ctaButton: 'Probeer Wan 2.5 op 微鲤AI',
        ctaDisclaimer: 'Geen creditcard vereist',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen videoweergave',
        videoLoadingError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // Page title and description
        pageTitle: 'Generator Video Wan 2.5 - Platform Pembuatan Video AI Lanjutan',
        pageDescription: 'Rasakan generator video Wan 2.5 yang berfokus pada pembuatan video berkualitas tinggi dan ekspresi kreatif. Mendukung berbagai mode pembuatan video untuk menghasilkan konten video indah dari deskripsi teks atau input gambar. Coba gratis di 微鲤AI.',
        pageKeywords: 'Wan 2.5, generator video AI, pembuatan video AI, video kecerdasan buatan, alat generasi video, video AI gratis, 微鲤AI, produksi video',

        // Generator section
        generatorTitle: 'Generator Video Wan 2.5',
        generatorDescription: 'Wan 2.5 adalah alat generasi gambar dan video AI canggih yang diluncurkan oleh raksasa e-commerce Tiongkok Alibaba, yang baru saja mengumumkan rencana investasi lebih dari $50 miliar di komputasi awan dan kecerdasan buatan. Modelnya',
        generatorDescriptionHighlight1: 'Wan 2.5 kini terintegrasi ke generator video 微鲤AI dan dapat menghasilkan video yang realistis',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'coba Wan 2.5 gratis',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Utama Model Video Wan 2.5',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Integrasi Audio Native',
        nativeAudioIntegrationDescription: 'Menghasilkan audio otomatis, mendukung unggah audio kustom, opsional',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Efek Dinamis yang Ditingkatkan',
        enhancedDynamicEffectsDescription: 'Merender aksi kompleks dengan detail yang lebih halus dan natural',

        // Precise camera control feature
        preciseCameraControlTitle: 'Kontrol Kamera Presisi',
        preciseCameraControlDescription: 'Memberikan ruang gerak lebih besar untuk produksi video sinematik.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Realisme Visual yang Ditingkatkan',
        enhancedVisualRealismDescription: 'Komposisi adegan yang lebih kaya dan lebih halus',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Pemahaman Konteks yang Lebih Baik',
        improvedContextUnderstandingDescription: 'Menafsirkan aksi karakter kompleks dan arahan adegan kreatif dengan lebih baik.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        step1Title: 'Pilih Model Wan 2.5',
        step1Description: 'Pergi ke halaman "AI Video Generation", lalu klik "Wan 2.5" di menu dropdown model.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Masukkan Konten Kreatif Anda',
        step2Description: 'Jelaskan konten yang ingin dibuat, atau unggah gambar untuk dikonversi, lalu sesuaikan parameter yang relevan.',
        step3Title: 'Unduh Video Anda',
        step3Description: 'Klik "Create" untuk mengunduh atau membagikan video berkualitas tinggi yang dihasilkan.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Model Video Wan 2.5',

        // X Posts section
        xPostsTitle: 'Posting X Populer tentang Model Video AI Wan 2.5',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Lain',
        sora2Title: 'Generator Video AI OpenAI Sora-2',
        runwayTitle: 'Generator Video AI Runway',
        veo31Title: 'Generator Video AI Google Veo 3.1',
        seedanceTitle: 'Generator Video Seedance 1.0 Pro',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: 'Apa itu Wan 2.5?',
        faq1Answer: 'Wan 2.5 adalah platform generasi video AI canggih yang berfokus pada pembuatan video berkualitas tinggi dan ekspresi kreatif. Mendukung berbagai mode generasi video dan dapat menghasilkan konten video indah berdasarkan deskripsi teks atau input gambar.',
        faq2Question: 'Apa fitur utama Wan 2.5?',
        faq2Answer: 'Fitur utama Wan 2.5 meliputi: generasi video berkualitas tinggi, dukungan ekspresi kreatif, dukungan input multimodal, opsi kontrol lanjutan, dan lainnya. Dapat menghasilkan konten video resolusi tinggi yang kaya detail serta mendukung berbagai gaya artistik dan metode ekspresi kreatif.',
        faq3Question: 'Bisakah saya menggunakan Wan 2.5 gratis?',
        faq3Answer: 'Ya. Wan 2.5 menyediakan kredit gratis terbatas melalui uji coba 微鲤AI. Untuk penggunaan intensif, diperlukan upgrade.',
        faq4Question: 'Metode input apa yang didukung Wan 2.5?',
        faq4Answer: 'Wan 2.5 mendukung berbagai metode input, termasuk deskripsi teks, input gambar, audio, dan lainnya. Dukungan input multimodal ini memungkinkan Anda mengekspresikan dan mewujudkan ide kreatif melalui berbagai media.',
        faq5Question: 'Bisakah saya menggunakan Wan 2.5 untuk proyek profesional atau komersial?',
        faq5Answer: 'Ya. Generasi video berkualitas tinggi dan kemampuan ekspresi kreatif yang kuat dari Wan 2.5 menjadikannya pilihan yang kuat bagi produser video profesional, kreator konten, dan pengguna komersial.',

        // CTA section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription: 'Coba Wan 2.5 sekarang dan ubah kreativitas Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Wan 2.5 di 微鲤AI',
        ctaDisclaimer: 'Tidak perlu kartu kredit',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle: 'Wan 2.5 Video Üretici - Gelişmiş AI Video Oluşturma Platformu',
        pageDescription: 'Yüksek kaliteli video üretimi ve yaratıcı ifadeye odaklanan Wan 2.5 video üreticisini deneyimleyin. Metin açıklamaları veya görsel girdilere dayalı güzel video içerikleri oluşturmak için birden fazla video üretim modunu destekler. 微鲤AI\'de ücretsiz deneyin.',
        pageKeywords: 'Wan 2.5, AI video üretici, AI video oluşturma, yapay zeka video, video üretim aracı, ücretsiz AI video, 微鲤AI, video prodüksiyon',

        // Generator section
        generatorTitle: 'Wan 2.5 Video Üretici',
        generatorDescription: 'Wan 2.5, Çinli e-ticaret devi Alibaba tarafından başlatılan gelişmiş bir AI görsel ve video üretim aracıdır. Alibaba yakın zamanda bulut bilişim ve yapay zekaya 50 milyar doların üzerinde yatırım planlarını açıkladı. Bu',
        generatorDescriptionHighlight1: 'Wan 2.5 modeli artık 微鲤AI video üreticisine entegre edildi ve gerçekçi videolar oluşturabiliyor',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'Wan 2.5\'i ücretsiz dene',
        generatorDescriptionEnd: '!',
        
        // Tabs
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Wan 2.5 Video Modelinin Temel Özellikleri',

        // Native audio integration feature
        nativeAudioIntegrationTitle: 'Yerleşik Ses Entegrasyonu',
        nativeAudioIntegrationDescription: 'Otomatik ses üretir, özel ses yüklemeyi destekler, isteğe bağlı',

        // Enhanced dynamic effects feature
        enhancedDynamicEffectsTitle: 'Geliştirilmiş Dinamik Efektler',
        enhancedDynamicEffectsDescription: 'Karmaşık hareketleri daha akıcı ve doğal detaylarla işler',

        // Precise camera control feature
        preciseCameraControlTitle: 'Hassas Kamera Kontrolü',
        preciseCameraControlDescription: 'Sinematik video prodüksiyonu için daha fazla esneklik sağlar.',

        // Enhanced visual realism feature
        enhancedVisualRealismTitle: 'Geliştirilmiş Görsel Gerçekçilik',
        enhancedVisualRealismDescription: 'Daha zengin ve daha rafine sahne kompozisyonu',

        // Improved context understanding feature
        improvedContextUnderstandingTitle: 'Geliştirilmiş Bağlam Anlayışı',
        improvedContextUnderstandingDescription: 'Karmaşık karakter eylemlerini ve yaratıcı sahne yönlendirmelerini daha iyi yorumlar.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        step1Title: 'Wan 2.5 Modelini Seçin',
        step1Description: '"AI Video Generation" sayfasına gidin, ardından model açılır menüsünden "Wan 2.5"i seçin.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Yaratıcı İçeriğinizi Girin',
        step2Description: 'Oluşturmak istediğiniz içeriği açıklayın veya dönüşüm için görseller yükleyin ve ilgili parametre ayarlarını yapın.',
        step3Title: 'Videonuzu İndirin',
        step3Description: '"Create"e tıklayarak oluşturulan yüksek kaliteli videoyu serbestçe indirin veya paylaşın.',

        // YouTube videos section
        youtubeTitle: 'Wan 2.5 Video Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Wan 2.5 AI Video Modeli Hakkında Popüler X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Modelleri Keşfet',
        sora2Title: 'OpenAI Sora-2 AI Video Üretici',
        runwayTitle: 'Runway AI Video Üretici',
        veo31Title: 'Google Veo 3.1 AI Video Üretici',
        seedanceTitle: 'Seedance 1.0 Pro Video Üretici',

        // FAQ section
        faqTitle: 'Sıkça Sorulan Sorular',
        faq1Question: 'Wan 2.5 nedir?',
        faq1Answer: 'Wan 2.5, yüksek kaliteli video üretimi ve yaratıcı ifadeye odaklanan gelişmiş bir AI video üretim platformudur. Birden fazla video üretim modunu destekler ve metin açıklamaları veya görsel girdilerle güzel video içerikleri üretebilir.',
        faq2Question: 'Wan 2.5\'in temel özellikleri nelerdir?',
        faq2Answer: 'Wan 2.5\'in temel özellikleri: yüksek kaliteli video üretimi, yaratıcı ifade desteği, çok modlu girdi desteği, gelişmiş kontrol seçenekleri vb. Yüksek çözünürlüklü ve detay zengin video içerikleri üretebilir ve çeşitli sanatsal stiller ile yaratıcı ifade yöntemlerini destekler.',
        faq3Question: 'Wan 2.5\'i ücretsiz kullanabilir miyim?',
        faq3Answer: 'Evet. Wan 2.5, 微鲤AI\'nin ücretsiz denemesiyle sınırlı kredi sağlar. Yoğun kullanım için yükseltme gerekir.',
        faq4Question: 'Wan 2.5 hangi girdi yöntemlerini destekler?',
        faq4Answer: 'Wan 2.5; metin açıklamaları, görsel girdiler, ses vb. birçok girdi yöntemini destekler. Bu çok modlu destek, yaratıcı fikirlerinizi farklı medyalarla ifade etmenizi ve hayata geçirmenizi sağlar.',
        faq5Question: 'Wan 2.5\'i profesyonel veya ticari projeler için kullanabilir miyim?',
        faq5Answer: 'Evet. Wan 2.5\'in yüksek kaliteli video üretimi ve güçlü yaratıcı ifade yetenekleri, profesyonel video üreticileri, içerik üreticileri ve ticari kullanıcılar için güçlü bir tercihtir.',

        // CTA section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription: 'Wan 2.5\'i şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaButton: '微鲤AI üzerinde Wan 2.5\'i deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yükleme başarısız',
        videoReload: 'Yeniden yükle',
    },
}
